import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CsrService} from '@evomatik/seaged-csr-library';
import {MessageCrudService} from '@evomatik/evk-common';
import {MatDialog} from '@angular/material/dialog';
import {ReqDialogComponent} from '../../../../../expediente/componentes/dialogs/req-dialog/req-dialog.component';
import {RequerimientoService} from '../../../../services/requerimiento.service';

@Component({
    selector: 'lib-cargar-requerimiento',
    templateUrl: './cargar-requerimiento.component.html',
    styleUrls: ['./cargar-requerimiento.component.css']
})
export class CargarRequerimientoComponent implements OnInit {

    @Output()
    infoExpediente: EventEmitter<any> = new EventEmitter<any>();

    public archivoCargado: EventEmitter<boolean> = new EventEmitter();

    public formReq: FormGroup;

    public valueReq: string;

    showValidIcon: boolean = false;

    showInvalidIcon: boolean = false;

    errorFile: boolean = false;

    errorMessage: string;

    protected get formBuildReq(): FormGroup {
        return this.fb.group({
            archivoReq: ['', [Validators.required]],
        });
    }

    constructor(
        public fb: FormBuilder,
        public dialog: MatDialog,
        public messageCrudService: MessageCrudService,
        private requeriminetoService: RequerimientoService,
        private csrService: CsrService,
    ) {
    }

    ngOnInit(): void {
        this.formReq = this.formBuildReq;

        this.archivoCargado.subscribe((res) => {
            if (res) {
                this.csrService.readCSR(this.valueReq).then(data => {
                    // console.log('Información Archivo Req: ', data);
                    this.showValidIcon = true;
                    this.continuar(data);
                })
                    .catch(error => {
                        console.log('Error: ', error);
                        this.showInvalidIcon = true;
                        this.errorFile = true;
                        this.errorMessage = 'Se produjo un error al leer el archivo: ' + error;
                    })
            }
        });
    }

    public handleFileSelect(evt) {
        this.showInvalidIcon = false;
        this.errorFile = false;
        const file = evt.target.files[0];
        if (file) {
            this.uploadDocument(file);
        }
    }

    uploadDocument(file) {
        let fileReader = new FileReader();
        fileReader.onload = () => {
            // console.log('Valor Archivo: ', fileReader.result);
            this.valueReq = fileReader.result.toString();
            this.archivoCargado.emit(true);
        }
        fileReader.readAsText(file);
    }

    continuar(data: any) {
        const dialogRef = this.dialog.open(ReqDialogComponent, {
            disableClose: true,
            data: {
                nombre: data.commonName ? data.commonName : '',
                email: data.emailAddress ? data.emailAddress : '',
                curp: data.serialNumber ? data.serialNumber : '',
                rfc: data.uniqueIdentifier ? data.uniqueIdentifier : ''
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const email = encodeURIComponent(data.emailAddress)
                this.requeriminetoService.getExpediente(email, data.serialNumber, data.uniqueIdentifier).subscribe(
                    (response: any) => {
                        console.log('Response: ', response);
                        this.infoExpediente.emit(response);
                    }, () => {
                        this.messageCrudService.snackbarMessage('Se produjo un error al consultar la información.');
                    }
                );
            }
            this.showValidIcon = false;
            this.formReq.controls['archivoReq'].setValue(null, {emitEvent: false});
            const fileInput = <HTMLInputElement>document.querySelector('ngx-mat-file-input[formcontrolname="archivoReq"] input[type="file"]');
            fileInput.value = null;
        });
    }

}
